"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _vue = _interopRequireDefault(require("vue"));
var htmlparser = _interopRequireWildcard(require("htmlparser2"));
var Colours = _interopRequireWildcard(require("@/helpers/Colours"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var EmojiProvider = _interopRequireWildcard(require("@/libs/EmojiProvider"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = _vue.default.component('irc-input', {
  props: ['placeholder'],
  data() {
    return {
      last_known_value: '',
      text_value: '',
      current_el: null,
      current_el_pos: 0,
      default_colour: null,
      default_bg_colour: null,
      code_map: Object.create(null),
      bg_code_map: Object.create(null)
    };
  },
  computed: {
    editor() {
      return this.$refs.editor;
    }
  },
  mounted() {
    this.focus();
    document.execCommand('styleWithCSS', false, true);
    document.execCommand('selectAll', false, null);
    document.execCommand('removeFormat', false, null);
  },
  methods: {
    onTextInput(event) {
      // Mobile devices trigger a textInput event for things such as autocompletion
      // and suggested words. Unfortunately they end with a return character which
      // is not what we expect, so prevent the original event from inserting anything
      // and manually place it in with the current word.
      if (event.data[event.data.length - 1] === '\n') {
        event.preventDefault();
        this.setCurrentWord(event.data.trim());
      }
    },
    onPaste(event) {
      event.preventDefault();
      if (typeof event.clipboardData !== 'undefined') {
        let ignoreThisPaste = false;
        let clpData = event.clipboardData;
        clpData.types.forEach(type => {
          let ignoreTypes = ['Files', 'image'];
          ignoreTypes.forEach(ig => {
            if (type.indexOf(ig) > -1) {
              ignoreThisPaste = true;
            }
          });
        });
        if (ignoreThisPaste) {
          return;
        }
        document.execCommand('insertText', false, clpData.getData('text/plain'));
      } else {
        // IE11
        let clpText = window.clipboardData.getData('Text');
        if (!clpText) {
          return;
        }
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        if (range) {
          range.deleteContents();
          range.insertNode(document.createTextNode(clpText));
        }
      }
      setTimeout(() => {
        this.updateValueProps();
      }, 0);
    },
    onDrop(event) {
      // Allow dragging of single emoji's from the message list
      const raw = event.dataTransfer.getData('text/html');
      if (!raw) {
        return;
      }
      let html = document.createElement('div');
      html.innerHTML = raw;
      if (html.childNodes.length === 0 || html.childNodes.length > 1) {
        return;
      }
      let node = html.childNodes[0];
      if (node instanceof HTMLImageElement && node.classList.contains('kiwi-messagelist-emoji')) {
        event.preventDefault();
        let emojis = EmojiProvider.getEmojis(node.alt.trim());
        if (!emojis.length) {
          return;
        }
        this.addImg(emojis[0].ascii, emojis[0].url, emojis[0].imgProps);
      }
    },
    onFocus(event) {
      // Chrome sometimes focus' the element but does not add the cursor
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1125078
      this.focus();

      // when the input is empty there are no children to remember the
      // current colours so upon regaining focus we must set them again
      if (!this.getRawText()) {
        if (this.default_bg_colour || this.default_colour) {
          this.applyDefaultColours();
        }
      }
      this.$emit('focus', event);
    },
    updateSpacing() {
      let editor = this.$refs.editor;
      if (!editor) {
        return;
      }

      // This will make sure any image nodes are padded with spaces
      editor.childNodes.forEach(node => {
        if (node.nodeName !== 'IMG') {
          return;
        }
        node.alt = node.alt.trim();
        if (node.previousSibling) {
          let text = node.previousSibling.textContent.replace(/\xA0/g, ' ');
          let isEmpty = text.length === 0;
          let isImg = node.previousSibling.nodeName === 'IMG';
          let isText = ['#text', 'SPAN'].includes(node.previousSibling.nodeName);
          if (isImg || isText && (isEmpty || text[text.length - 1].indexOf(' ') === -1)) {
            // The previous node is an image or text and does not end with a space
            node.alt = ' ' + node.alt;
          }
        }
        if (node.nextSibling) {
          let text = node.nextSibling.textContent.replace(/\xA0/g, ' ');
          let isNeeded = text.length !== 0 || !node.nextSibling.nextSibling;
          let isText = ['#text', 'SPAN'].includes(node.nextSibling.nodeName);
          if (isText && isNeeded && (text.length === 0 || text[0].indexOf(' ') === -1)) {
            // The next node is text and does not start with a space
            node.alt += ' ';
          }
        }
      });
    },
    updateValueProps() {
      if (!this.$el.contains(document.activeElement)) {
        // Focused element is not a child of IrcInput
        // selection would not be relevant
        return;
      }
      let selection = window.getSelection();
      if (selection.rangeCount === 0) {
        return;
      }
      this.current_el_pos = selection.anchorOffset;
      this.current_el = selection.anchorNode;
      this.maybeEmitInput();
    },
    selectionToEnd() {
      // Move the caret to the end
      let el = this.$refs.editor.lastChild || this.$refs.editor;
      this.current_el = el;
      if (el.nodeType === 3) {
        this.current_el_pos = el.length;
      } else if (this.$el.contains(document.activeElement)) {
        // IrcInput has focus select all content and collapse to end
        document.execCommand('selectAll', false, null);
        document.getSelection().collapseToEnd();
        this.updateValueProps();
      } else {
        this.current_el_pos = 0;
      }
    },
    setValue(newVal) {
      this.value = newVal;
      this.$refs.editor.innerHTML = newVal;
      if (!newVal && (this.default_bg_colour || this.default_colour)) {
        this.applyDefaultColours();
      }
    },
    getValue() {
      return this.$refs.editor.innerHTML;
    },
    maybeEmitInput() {
      let currentHtml = this.$refs.editor.innerHTML;
      if (this.last_known_value !== currentHtml) {
        this.$emit('input', currentHtml);
        this.last_known_value = currentHtml;
      }
    },
    buildIrcText() {
      this.updateSpacing();
      let source = this.$refs.editor.innerHTML;
      let textValue = '';

      // Toggles are IRC style and colour codes that should be reset at the end of
      // the current tag
      let toggles = [];
      function addToggle(t) {
        toggles[toggles.length - 1] += t;
      }
      function getToggles() {
        return toggles[toggles.length - 1];
      }
      let currentFgCode = this.default_colour ? this.default_colour.code : '01';
      let parser = new htmlparser.Parser({
        onopentag: (name, attribs) => {
          toggles.push('');
          let codeLookup = '';
          if (attribs.style) {
            let fgCode = '';
            let bgCode = '';
            let match = attribs.style.match(/(?<![_-])color: ([^;]+)/);
            if (match) {
              codeLookup = match[1];
              fgCode = this.code_map[codeLookup];
              if (!fgCode) {
                // If we didn't have an IRC code for this
                // colour, convert to hex and check again
                let m = codeLookup.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                if (m) {
                  let hex = Colours.rgb2hex({
                    r: parseInt(m[1], 10),
                    g: parseInt(m[2], 10),
                    b: parseInt(m[3], 10)
                  });
                  fgCode = this.code_map[hex];
                }
              }
            }
            let bgMatch = attribs.style.match(/background-color: ([^;]+)/);
            if (bgMatch) {
              let bgLookup = bgMatch[1];
              bgCode = this.bg_code_map[bgLookup];
              if (!bgCode) {
                let m = bgLookup.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                if (m) {
                  let hex = Colours.rgb2hex({
                    r: parseInt(m[1], 10),
                    g: parseInt(m[2], 10),
                    b: parseInt(m[3], 10)
                  });
                  bgCode = this.bg_code_map[hex];
                }
              }
            }
            if (fgCode && bgCode) {
              currentFgCode = fgCode;
              let code = '\x03' + fgCode + ',' + bgCode;
              textValue += code;
              addToggle(code);
            } else if (fgCode) {
              currentFgCode = fgCode;
              textValue += '\x03' + fgCode;
              addToggle('\x03' + fgCode);
            } else if (bgCode) {
              let code = '\x03' + currentFgCode + ',' + bgCode;
              textValue += code;
              addToggle(code);
            }
            if (attribs.style.indexOf('bold') > -1) {
              textValue += '\x02';
              addToggle('\x02');
            }
            if (attribs.style.indexOf('italic') > -1) {
              textValue += '\x1d';
              addToggle('\x1d');
            }
            if (attribs.style.indexOf('underline') > -1) {
              textValue += '\x1f';
              addToggle('\x1f');
            }

            // Welcome to the IE/Edge sucks section, time to do crazy things
            // IE11 doesnt support document.execCommand('styleWithCSS')
            // so we have individual nodes instead, which are handled below
          } else if (attribs.color) {
            // IE likes to remove spaces from rgb(1, 2, 3)
            // it also likes converting rgb to hex
            let mappedCode = this.code_map[attribs.color] || this.code_map[attribs.color.replace(/,/g, ', ')] || this.code_map[Colours.hex2rgb(attribs.color)];
            if (mappedCode) {
              textValue += '\x03' + mappedCode;
              addToggle('\x03' + mappedCode);
            }
          } else if (name === 'strong') {
            textValue += '\x02';
            addToggle('\x02');
          } else if (name === 'em') {
            textValue += '\x1d';
            addToggle('\x1d');
          } else if (name === 'u') {
            textValue += '\x1f';
            addToggle('\x1f');
          } else if (name === 'div' || name === 'br') {
            // divs and breaks are both considered newlines. For each line we need to
            // close all current toggles and then reopen them for the next so that the
            // styles continue .
            textValue += getToggles();
            textValue += '\n';
            textValue += getToggles();
          }
          if (name === 'img' && attribs.alt) {
            textValue += attribs.alt;
          }
        },
        ontext: text => {
          textValue += text;
        },
        onclosetag: tagName => {
          textValue += getToggles();
          toggles.pop();
        }
      }, {
        decodeEntities: true
      });
      parser.write(source);
      parser.end();

      // Firefox likes to add <br/> at the end (some times inside the span)
      // fix by filtering out any lines that contain no content
      // Strip zero-width spaces used as background colour anchors
      textValue = textValue.replace(/\u200B/g, '');

      // If a default background colour is active (set on the editor
      // element), prepend the BG code to each line of output
      if (this.default_bg_colour && textValue) {
        let bgPrefix = '\x03' + currentFgCode + ',' + this.default_bg_colour.code;
        textValue = textValue.split(/\r?\n/).map(line => Misc.stripStyles(line) ? bgPrefix + line : line).join('\n');
      }
      return textValue.split(/\r?\n/).filter(line => !!Misc.stripStyles(line)).join('\n');
    },
    reset(rawHtml, shouldFocus) {
      this.$refs.editor.innerHTML = rawHtml || '';
      this.current_el_pos = 0;
      this.current_el = this.$refs.editor;

      // Firefox inserts a <br> on empty contenteditables after it's been reset. But that
      // fucks up the placeholder :empty CSS selector we use. So just remove it.
      let br = this.$refs.editor.querySelector('br');
      if (br) {
        br.parentNode.removeChild(br);
      }
      if (shouldFocus) {
        this.focus();
        if (this.default_bg_colour || this.default_colour) {
          this.applyDefaultColours();
        }
        this.updateValueProps();
      } else {
        this.maybeEmitInput();
      }
    },
    resetStyles() {
      this.focus();
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('selectAll', false, null);
      document.execCommand('removeFormat', false, null);
      this.default_colour = null;
      this.default_bg_colour = null;
      this.$emit('default-colour-change', null);
      this.$emit('default-bg-colour-change', null);
    },
    setColour(code, colour) {
      // If no current text selection, set this colour as the default colour for
      // future messages too
      let range = window.getSelection().getRangeAt(0);
      if (range && range.collapsed) {
        this.default_colour = {
          code,
          colour
        };
        this.$emit('default-colour-change', this.default_colour);
        // Update any existing colour-styled spans in the editor
        let editor = this.$refs.editor;
        let spans = editor.querySelectorAll('[style*=color]');
        spans.forEach(span => {
          span.style.color = colour;
        });
      }
      this.focus();
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('foreColor', false, colour);
      this.code_map[colour] = code;
      this.updateValueProps();
    },
    setBackgroundColour(code, colour) {
      this.focus();
      let sel = window.getSelection();
      let range = sel.getRangeAt(0);
      if (range && range.collapsed) {
        this.default_bg_colour = {
          code,
          colour
        };
        this.$emit('default-bg-colour-change', this.default_bg_colour);
        // Update any existing bg-styled spans in the editor
        let editor = this.$refs.editor;
        let spans = editor.querySelectorAll('[style*=background]');
        spans.forEach(span => {
          span.style.backgroundColor = colour;
        });
      } else {
        document.execCommand('styleWithCSS', false, true);
        document.execCommand('hiliteColor', false, colour);
      }
      this.bg_code_map[colour] = code;
      this.updateValueProps();
    },
    applyDefaultColours() {
      // Create a styled span with cursor inside it so typed
      // text inherits the colours. Uses two ZWS chars to keep
      // the cursor unambiguously inside the span boundaries.
      let editor = this.$refs.editor;
      let span = document.createElement('span');
      if (this.default_bg_colour) {
        span.style.backgroundColor = this.default_bg_colour.colour;
      }
      if (this.default_colour) {
        span.style.color = this.default_colour.colour;
      }
      span.textContent = '\u200B\u200B';
      editor.appendChild(span);
      let range = document.createRange();
      range.setStart(span.firstChild, 1);
      range.collapse(true);
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    },
    toggleBold() {
      document.execCommand('bold', false, null);
      this.updateValueProps();
    },
    toggleItalic() {
      document.execCommand('italic', false, null);
      this.updateValueProps();
    },
    toggleUnderline() {
      document.execCommand('underline', false, null);
      this.updateValueProps();
    },
    addImg(alt, url, props) {
      this.focus();
      let existingImages = [..._lodash.default.values(this.$refs.editor.querySelectorAll('img'))];
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('insertImage', false, url);
      let newImg = null;
      let images = [..._lodash.default.values(this.$refs.editor.querySelectorAll('img'))];

      // Find image that has just been inserted
      images.forEach(img => {
        if (existingImages.indexOf(img) === -1) {
          newImg = img;
        }
      });
      newImg.alt = alt;
      Object.assign(newImg, props);
      if (this.default_bg_colour) {
        newImg.style.backgroundColor = this.default_bg_colour.colour;
      }

      // Find the position of this new image node
      let prevElCnt = 0;
      let el = newImg;
      while (el) {
        el = el.previousSibling;
        prevElCnt++;
      }
      this.current_el = this.$refs.editor;
      this.current_el_pos = prevElCnt;
      this.updateValueProps();
      this.focus();

      // If default colours are set, insert a styled span after the
      // image so subsequent typing inherits the colours
      if (this.default_bg_colour || this.default_colour) {
        let span = document.createElement('span');
        if (this.default_bg_colour) {
          span.style.backgroundColor = this.default_bg_colour.colour;
        }
        if (this.default_colour) {
          span.style.color = this.default_colour.colour;
        }
        span.textContent = '\u200B\u200B';
        let sel = window.getSelection();
        let range = sel.getRangeAt(0);
        range.collapse(false);
        range.insertNode(span);
        let newRange = document.createRange();
        newRange.setStart(span.firstChild, 1);
        newRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(newRange);
        this.updateValueProps();
      }
    },
    // Insert some text at the current position
    insertText(text) {
      this.focus();
      document.execCommand('insertText', false, text);
      this.updateValueProps();
      this.focus();
    },
    // Replace the word at the current position with another
    setCurrentWord(text, keepPosition, toPosition) {
      let el = this.current_el;
      let pos = this.current_el_pos;
      let val = el.textContent || '';
      let startVal = val.substr(0, pos);
      let space = startVal.replace(/\xA0/g, ' ').lastIndexOf(' ');
      if (space === -1) {
        space = 0;
      } else {
        // include the space after the word
        space++;
      }
      let startPos = space;
      let endVal = val.substr(pos);
      space = endVal.replace(/\xA0/g, ' ').indexOf(' ');
      if (space === -1) space = endVal.length;
      let endPos = toPosition ? 0 : space;
      el.textContent = startVal.substr(0, startPos) + text + endVal.substr(endPos);

      // Move the caret after the word
      let range = document.createRange();
      if (keepPosition) {
        range.setStart(el, pos);
        range.setEnd(el, pos);
      } else if (el.nodeType === 3) {
        // TEXT_NODE
        range.setStart(el, startPos + text.length);
        range.setEnd(el, startPos + text.length);
      } else {
        // el is another type of node, so setStart/End() counts in nodes instead
        // of text length
        range.setStart(el, 1);
        range.setEnd(el, 1);
      }

      // ensure the input has focus so the cursor position can be set correctly
      this.$refs.editor.focus();
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      this.updateValueProps();
    },
    getCurrentWord(toPosition) {
      let el = this.current_el;
      let pos = this.current_el_pos;
      let val = el.textContent;
      let cleanVal = val.replace(/\xA0/g, ' ');
      let startVal = cleanVal.substr(0, pos);
      let space = startVal.lastIndexOf(' ');
      if (space === -1) {
        space = 0;
      } else {
        // include the space after the word
        space++;
      }
      let startPos = space;
      space = cleanVal.indexOf(' ', startPos);
      if (space === -1) {
        space = val.length;
      }
      let endPos = toPosition ? pos - startPos : space;
      return {
        word: val.substr(startPos, endPos).replace(/\u200B/g, ''),
        position: pos - startPos
      };
    },
    getCaretIdx() {
      let position = 0;
      let selection = window.getSelection();
      if (selection.rangeCount !== 0) {
        let range = window.getSelection().getRangeAt(0);
        let caretRange = range.cloneRange();
        caretRange.selectNodeContents(this.$el);
        caretRange.setEnd(range.endContainer, range.endOffset);
        position = caretRange.toString().length;
      }
      return position;
    },
    getRawText() {
      return this.$refs.editor.innerText;
    },
    // Focus the editable div and move the caret to the end
    focus() {
      let selection = window.getSelection();
      let range = document.createRange();
      range.setStart(this.current_el || this.$refs.editor, this.current_el_pos || 0);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["IrcInput"]
window._kiwi_exports.components.utils.IrcInput = exports.default ? exports.default : exports;
